import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { DeviceSyncStatusEffects } from './device-sync-status.effects';
import { deviceSyncStatusFeatureKey, DeviceSyncStatusReducer } from './device-sync-status.reducer';

export const provideDeviceSyncStatusesStore = () => [
  provideState(deviceSyncStatusFeatureKey, DeviceSyncStatusReducer),
  provideEffects([DeviceSyncStatusEffects]),
];
